import { Component, NgZone, OnInit } from "@angular/core";
import { localDataService, localDataServices } from "../../Services/localDataServices";
import { Router, ActivatedRoute } from '@angular/router';
import { NzMessageService, NzModalService } from 'ng-zorro-antd';
import { Location } from '@angular/common';
import { C } from "@angular/core/src/render3";
import { promise } from "protractor";
import { resolve } from "url";
import { PromiseType } from "protractor/built/plugins";
import { format } from "date-fns";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { debounceTime } from 'rxjs/operators/debounceTime';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { differenceInDays } from 'date-fns';
import { log } from "console";
declare var $: any;  //定义jquery
declare var async: any;  //定义jquery

const defalutValue = { value: '' };
const defalutAttrJson = {
    shipper: { value: '' }, // 发货人
    ourCompanyNo: { value: '' }, // 同行编号
    placeOfReceiptStandard: { value: '' }, // 收货地
    placeOfReceiptMP: { value: '' }, // 收货地五字码
    consignee: { value: '' }, // 收货人
    notifyParty: { value: '' }, // 通知人
    portOfLoadingStandard: { value: '' }, // 起运港
    portOfLoadingMP: { value: '', msg: '' }, // 起运港五字码
    portOfDischargeStandard: { value: '' }, // 卸货港
    portOfDischargeMP: { value: '', msg: '' }, // 卸货港五字码
    portOfDestinationStandard: { value: '' }, // 目的港
    portOfDestinationMP: { value: '', msg: '' }, // 目的港五字码
    numberOfPieces: { value: '' }, // 件数
    grossWeight: { value: '' }, // 毛重
    volume: { value: '' }, // 体积
    packing: { value: '' }, // 包装
    etd: { value: '' }, // 要求ETD
    serviceTerm: { value: '' }, // 运输条款
    paymenTerm: { value: '' }, // 运费条款
    client: { value: '' }, // 委托方
    contacts: { value: '' }, // 联系人
    contactPhone: { value: '' }, // 联系人电话
    goodName: { value: '' }, // 品名
    marks: { value: '' }, // 唛头
    remarks: { value: '' }, // 备注
    /* -------------------------- */
    imgPath: '', // 图片
    originalPath: '' // 源文件
}

@Component({
    selector: 'identification',
    providers: [localDataServices],
    templateUrl: './identification.html',
    styleUrls: ['./identification.css']
})

export class identificationNewComponent {
    tabs: 'tabs1' | 'tabs2' = 'tabs1';
    isFillLayout: boolean = false;
    token: string;
    orderNo: string;
    delays: number = 0;
    setDelays: number = 20;
    modalVibisity: boolean = false;
    delaysLoading: boolean = false;
    mesText: string = '正在上传您的托书…';
    attrJson: any = defalutAttrJson;
    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _localDataService: localDataService,
        private _location: Location,
        private modal: NzModalService,
        private ngZone: NgZone,
        private message: NzMessageService
    ) {

    }


    ngAfterContentInit() {
        $('#myModal').on('hidden.bs.modal', (e) => {
            this.ngZone.run(() => {
                this.openModalType = null;
                this.focusIdx = -1
                this.checkedIdx - 1
                document.querySelector('.modal-body-table').scrollTop = 0
            })
        })
        $('#exampleModal').on('hidden.bs.modal', (e) => {
            this.ngZone.run(() => {
                this.portForm = { portName: '', portCode: '' };
                this.portVName = false;
                this.portVCode = false;
                this.portCodeArray = [];
            })
        })
    }


    // 获取 单证数据 
    isTypeDate: boolean = true;
    identifyData(params: any = { token: this.token, orderNo: this.orderNo }) {
        this.modalVibisity = true;
        if (this.delays >= this.setDelays) { this.delays = 0 }
        let timer = setInterval(() => {
            if (this.delays >= this.setDelays) { return clearInterval(timer) }
            if (this.stopAiFlag) return clearInterval(timer)
            this.delays++;
        }, 1200)

        this._localDataService.identDetails(params)
            .then((res: any) => {
                if (this.stopAiFlag) return clearInterval(timer)
                let { status, data: { attrJson = defalutAttrJson }, message } = res;
                if (status) {
                    try {
                        if (attrJson.etd.value) {
                            attrJson.etd.value = format(new Date(attrJson.etd.value), 'yyyy-MM-dd');
                        }
                    } catch (error) {
                        try {
                            if (attrJson.etd.value) {
                                const formatDate = attrJson.etd.value.replace('日', '').replace(/年|月/g, '-')
                                attrJson.etd.value = format(new Date(formatDate), 'yyyy-MM-dd');
                            }
                        } catch (error) {
                            console.error('etd.value:' + attrJson.etd.value);
                            attrJson.etd.value = null;
                        }
                    }
                    const { portOfLoadingStandard = defalutValue, portOfLoadingMP = defalutValue, portOfDischargeStandard = defalutValue, portOfDischargeMP = defalutValue, portOfDestinationStandard = defalutValue, portOfDestinationMP = defalutValue } = attrJson;
                    this.attrJson = {
                        ...attrJson,
                        portOfLoadingStandard: { value: [portOfLoadingStandard.value, portOfLoadingMP.value].join(';') }, // 起运港
                        portOfDischargeStandard: { value: [portOfDischargeStandard.value, portOfDischargeMP.value].join(';') }, // 卸货港
                        portOfDestinationStandard: { value: [portOfDestinationStandard.value, portOfDestinationMP.value].join(';') }, // 目的港
                    };
                    this.optionList = {
                        'packing': [attrJson.packing.value],
                        'serviceTerm': [attrJson.serviceTerm.value],
                        'paymenTerm': [attrJson.paymenTerm.value],
                        'portOfLoadingStandard': attrJson.portOfLoadingStandard.value && [{ portName: attrJson.portOfLoadingStandard.value, portCode: attrJson.portOfLoadingMP.value }],
                        'portOfDischargeStandard': attrJson.portOfDischargeStandard.value && [{ portName: attrJson.portOfDischargeStandard.value, portCode: attrJson.portOfDischargeMP.value, }],
                        'portOfDestinationStandard': attrJson.portOfDestinationStandard.value && [{ portName: attrJson.portOfDestinationStandard.value, portCode: attrJson.portOfDestinationMP.value }],
                    }
                    clearInterval(timer);
                    this.modalVibisity = false;
                    this.initCompiled(true) // 处理 etd 船期 时间 限制 
                    this.warningMsg('grossWeight', attrJson.grossWeight.value)
                    this.warningMsg('volume', attrJson.volume.value)
                    this.warningMsg('numberOfPieces', attrJson.numberOfPieces.value)
                    // this.drawLoading();

                } else {
                    this.modal.warning(message)
                    clearInterval(timer);
                    this.modalVibisity = false;
                }
            })
    }
    // 保存
    updataHander(event, setType) {
        let $btn = $(event.target).button('loading')
        if (this.attrJson.etd.value) {
            this.attrJson.etd.value = format(new Date(this.attrJson.etd.value), 'yyyy-MM-dd');
        }
        this._localDataService.saveIdentDetails({ token: this.token, orderNo: this.orderNo, msCoID: this.msCoID, orderStatus: setType, attrJson: this.attrJson })
            .then((res: any) => {
                let { code, message } = res;
                this.message.success((setType ? '发送' : '保存') + message)
                $btn.button('reset');
            })
    }
    msCoID: any;
    getSomeType() {
        this._localDataService.getThisCompanyHaveSomeType(this.token).then((res: any) => {
            if (res.status) {
                this.msCoID = res.data.filter((item) => item.code === 'W0001')[0]['coBizId'];
            } else {
                console.log(res.message);
            }
        })
    }
    // 图片缩放功能
    degNum: number = 1;
    // 图片放大 
    onBig(event) {
        if (this.degNum <= 2) {
            this.degNum = this.degNum + 0.2
        }
    }
    // 图片缩小
    onSmall(event) {
        if (this.degNum > 0.2) {
            this.degNum = this.degNum - 0.2;
        }
    }
    lineWidth: string = '0px'
    lineHeight: string = '0px'
    lineTop: string = '0px'
    lineLeft: string = '0px'
    // input focus 标记 红色位置
    drawTag(rows) {
        let { width } = this.attrJson;
        let imgwidth = $('.tuoshuimg').find('img').css("width").split("px")[0];
        this.lineWidth = Number(rows.right - rows.left) * Number(imgwidth / width) + 'px';
        this.lineHeight = Number(rows.bottom - rows.top) * Number(imgwidth / width) + 'px';
        this.lineTop = Number(rows.top) * Number(imgwidth / width) + 'px';
        this.lineLeft = Number(rows.left) * Number(imgwidth / width) + 'px';
    }
    // 清除 标记
    clearTag() {
        this.lineWidth = '0px'
        this.lineHeight = '0px'
        this.lineTop = '0px'
        this.lineLeft = '0px'
    }
    // 固定宽度1200  切换
    onLayoutHander() {
        this.isFillLayout = !this.isFillLayout
    }
    // tabs 切换 
    onceSetIframeScore = null;
    onTab(activeTab) {
        this.tabs = activeTab;
        if (activeTab === 'tabs2') {
            $('.iframeScore').height($('.tibcontant').height() - 10)
            if (this.onceSetIframeScore === null) {
                if (this.attrJson.originalPath.toLocaleLowerCase().indexOf("pdf") > -1) {
                    // Pdf
                    this.onceSetIframeScore = this.attrJson.originalPath + '?' + new Date().getTime();
                } else if (/^png|jpg|gif$/g.test(this.attrJson.originalPath)) {
                    this.onceSetIframeScore = this.attrJson.originalPath + '?' + new Date().getTime();
                }
                else {
                    // Excel
                    this.onceSetIframeScore = "https://view.officeapps.live.com/op/view.aspx?src=" + this.attrJson.originalPath + '?' + new Date().getTime();
                }

                $('.iframeScore').attr('src', this.onceSetIframeScore);
            }
        }
    }

    drawLoading() {
        let cvs = <HTMLCanvasElement>document.getElementById('loading-canvans');
        cvs.width = 1200;
        cvs.height = 800;
        let cvsCxt = cvs.getContext('2d');
        cvsCxt.arc(0, 0, 360, 0, 360)
        cvsCxt.stroke();
    }

    openModalType = null;
    openModalName = '';
    // 获取对应的五字码
    onKeyUpHander(event, type, codeType) {
        event.preventDefault();
        event.stopPropagation();
        this.openModalType = type;
        this.openModalName = event.target.parentElement.parentElement.children[0].innerText.replace(/[A-z]/g, '');
        event.target.blur()
        this._localDataService.getCodeByNameSc({ type: codeType, orderNo: this.orderNo, portName: event.target.value, token: this.token })
            .then((res: any) => {
                console.log(res);

                const { code, data, message } = res;
                if (code !== 200) {
                    return this.message.error(message);
                }
                this.attrJson[type].value = data;
                if (data === '') {
                    $('#myModal').modal('show');
                    this.searchForm.portName = event.target.value;
                    this.onMPSearchHander(event);
                }
            })
    }
    ondbKeyUpHander(event, type, codeType) {
        event.preventDefault();
        event.stopPropagation();
        this.openModalType = type;
        this.openModalName = event.target.parentElement.parentElement.previousElementSibling.innerText.replace(/[A-z]/g, '');
        let portName = (this.attrJson[type.replace('MP', 'Standard')].value || ";").split(';')[0] || '';
        $('#myModal').modal('show');
        this.searchForm.portName = portName;
        if (portName) {
            this.onMPSearchHander(event);
        } else {
            this.tableData = [];
            this.checkedIdx = -1
        }
    }


    tableData: any = [];
    searchForm: any = { portName: '', portCode: '' };
    onMPSearchHander(event) {
        try {
            this._localDataService.getPostCodeList({ ...this.searchForm, token: this.token })
                .then((res: any) => {
                    const { code, data, message } = res;
                    if (code !== 200) {
                        return this.message.error(message)
                    }
                    if (data.length > 0) {
                        this.tableData = data;
                        this.onClickTd(null, 0)
                        return
                    }
                    this.tableData = data;
                    this.checkedIdx = -1
                })
        } catch (error) {
        }

    }

    // td 点击
    checkedIdx: number = 0;
    focusIdx: number = 0;
    hasKeyEvent = null;
    onClickTd(event, tdIdx) {
        this.checkedIdx = tdIdx;
        this.bindBoard()
    }
    bindBoard() {
        const modalEl = document.querySelector('#myModal');
        if (this.hasKeyEvent) {
            modalEl.removeEventListener('keyup', this.hasKeyEvent, true);
        }
        const ctxBoard = this.tableBoard(this.checkedIdx);
        this.hasKeyEvent = ctxBoard;
        modalEl.addEventListener('keyup', ctxBoard, true);
    }
    tableBoard(checkedIdx) {
        let tdIdx = checkedIdx;
        let scrollElement = document.querySelector('.modal-body-table') as HTMLElement;
        let tr = scrollElement.querySelectorAll('tr');
        let scrollHeight = scrollElement.offsetHeight;
        return (event) => {
            event.preventDefault()
            event.stopPropagation()
            if (this.portNameEnter(event) === false) {
                return
            }; // 港口名称 回车

            if (event.target.tagName === 'INPUT' && event.keyCode === 13) {
                event.target.blur()
                this.onMPSearchHander(event);
                return;
            }
            if (event.target.tagName === 'BUTTON' && event.keyCode === 13) {
                return;
            }
            if (this.tableData.length) {
                // 向上
                if (event.keyCode === 38 && tdIdx) {
                    tdIdx--;
                    if ((tr[tdIdx].offsetTop - scrollHeight / 2) <= scrollElement.scrollTop) {
                        scrollElement.scrollTop = tr[tdIdx].offsetTop - scrollHeight / 2;
                    }
                }
                // 向下
                if (event.keyCode === 40 && tdIdx < this.tableData.length - 1) {
                    tdIdx++;
                    if ((tr[tdIdx].offsetTop - scrollHeight / 2) > scrollElement.scrollTop) {
                        scrollElement.scrollTop = tr[tdIdx].offsetTop - scrollHeight / 2;
                    }
                }
                this.focusIdx = tdIdx;
                if (event.keyCode === 13 && tdIdx !== this.checkedIdx) {
                    this.checkedIdx = tdIdx;
                } else if (event.keyCode === 13 && tdIdx === this.checkedIdx) {
                    this.backfill();
                }
            }
        }
    }
    portNameEnter(event) {
        if (event.target.tagName === 'INPUT' && event.keyCode === 13) {
            event.target.blur()
            this.onMPSearchHander(event);
            return false;
        }
        if (event.target.tagName === 'BUTTON' && event.keyCode === 13) {
            return false;
        }

    }
    verifyMpCode(event, type, codeType) {
        this._localDataService.getCodeByNameSc({ type: codeType, orderNo: this.orderNo, portName: event.target.value, token: this.token })
            .then((res: any) => {
                console.log(res);

                const { code, data, message } = res;
                if (code !== 200) {
                    return this.message.error(message);
                }
                this.attrJson[type].value = data;
            })
    }
    backfill() {
        const data = this.tableData.filter((it, idx) => idx === this.checkedIdx)
        try {
            if (data.length) {
                const mp = this.openModalType;
                const name = this.openModalType.replace('MP', 'Standard');
                this.attrJson[mp].value = data[0].portCode || '';
                this.attrJson[name].value = data[0].portName + ';' + data[0].portCode || '';
                this.attrJson[mp].msg = '';
                this.optionList[name] = data;
                this.initCompiled();
            }
        } catch (error) {
            this.message.error('回车选中数据失败请开发者检查')
        }
        $('#myModal').modal('hide')
    }
    portForm = { portName: '', portCode: '' }
    portVName = false;
    portVCode = false;
    updateOrAddPortCode() {
        if (this.portForm.portName === '') {
            this.portVName = true;
            return;
        }
        this.portVName = false;
        if (!/^[A-Z]{5}$/.test(this.portForm.portCode)) {
            this.portVCode = true;
            return;
        }
        this.portVCode = false;
        this._localDataService.updateOrAddPortCode({ ...this.portForm, token: this.token })
            .then((res: any) => {
                const { code, data, message } = res;
                if (code !== 200) {
                    return this.message.error(message);
                }
                this.message.success(message);
                $('#exampleModal').modal('hide')
            })


    }
    portCodeArray: any[] = []
    dorpDown: boolean = false
    portCodeInput() {
        if (this.searchForm.portCode !== '') {
            this._localDataService.getCodeByCode({ portCode: this.searchForm.portCode, token: this.token })
                .then((res: any) => {
                    const { code, data, message } = res;
                    if (code !== 200) {
                        return this.message.error(message)
                    }
                    this.dorpDown = true;
                    this.portCodeArray = data;

                })
        } else {
            this.dorpDown = false;
            this.portCodeArray = [];
        }

        console.log('input1');
    }
    throttle(fn, second) {
        if (fn.timer) {
            clearTimeout(fn.timer);
        }
        fn.timer = setTimeout(() => {
            fn.call(this)
        }, second)
    }
    portCodeBlur(event) {
        setTimeout(() => {
            this.dorpDown = false
        }, 200)
    }
    deletePortCode(event, mp) {
        event.stopPropagation();
        const { id, portType } = mp
        if (id && portType) {
            this._localDataService.deletePortCode({ id: id, token: this.token })
                .then((res: any) => {
                    const { code, data, message } = res
                    if (code !== 200) {
                        return this.message.error(message);
                    }
                    this.message.success(message)
                    this.onMPSearchHander(event)
                })
        }
    }
    stopAiFlag = false
    //直接上传给美设客服
    directUpload() {
        // let $btn = $(event.target).button('loading')
        // if (this.attrJson.etd.value) {
        //     this.attrJson.etd.value = format(new Date(this.attrJson.etd.value), 'yyyy-MM-dd');
        // }
        this.stopAiFlag = true;
        this.modalVibisity = false;
        this.delaysLoading = true;
        this._localDataService.saveIdentDetailsNew({ token: this.token, orderNo: this.orderNo, msCoID: undefined, orderStatus: undefined, attrJson: undefined, businessType: '3' })
            .then((res: any) => {
                let { code, message, data } = res;
                if (code == 200) {
                    this.modal.success({
                        nzTitle: '',
                        nzContent: '您的托书已上传，美设客服将会收到实时通知，客服受理之后会及时通知您。',
                        nzOnOk: () => {
                            location.replace(data)
                        }
                    })
                } else {
                    this.mesText = message
                }
            })
    }

    mustData = [
        {
            name: 'portOfLoadingMP',
            cn: '起运港'
        },
        {
            name: 'portOfDischargeStandard',
            cn: '卸货港名称'
        },
        {
            name: 'portOfDestinationStandard',
            cn: '目的港名称'
        },
        {
            name: 'etd',
            cn: '开航日'
        },
        {
            name: 'numberOfPieces',
            cn: '件数'
        },
        {
            name: 'grossWeight',
            cn: '毛重'
        },
        {
            name: 'volume',
            cn: '体积'
        },
        {
            name: 'packing',
            cn: '包装'
        },
        {
            name: 'serviceTerm',
            cn: '运输条款'
        },
        {
            name: 'paymenTerm',
            cn: '运费条款'
        },
    ]
    mustData2 = [
        {
            name: 'portOfLoadingMP',
            cn: '起运港'
        },
        {
            name: 'portOfDischargeMP',
            cn: '卸货港'
        },
        {
            name: 'portOfDestinationMP',
            cn: '目的港'
        },
        {
            name: 'etd',
            cn: '开航日期'
        },
    ]
    //提交订舱
    submitBooking(event) {
        let arr = []
        this.mustData.forEach(item => {
            if (!this.attrJson[item.name].value) {
                arr.push(item.cn)
            }
        })
        if (arr.length > 0) {
            this.openModal()
        } else {
            const submit = () => {
                let $btn = $(event.target).button('loading')
                if (this.attrJson.etd.value) {
                    this.attrJson.etd.value = format(new Date(this.attrJson.etd.value), 'yyyy-MM-dd');
                }
                this.isSpinning = true;
                const { portOfLoadingStandard = defalutValue, portOfDischargeStandard = defalutValue, portOfDestinationStandard = defalutValue } = this.attrJson;

                const formatAttrJson = {
                    ...this.attrJson, portOfLoadingStandard: { value: portOfLoadingStandard.value.split(';')[0] }, // 起运港
                    portOfDischargeStandard: { value: portOfDischargeStandard.value.split(';')[0] }, // 卸货港
                    portOfDestinationStandard: { value: portOfDestinationStandard.value.split(';')[0] },
                } // 目的港 }
                this._localDataService.saveIdentDetailsNew({ token: this.token, orderNo: this.orderNo, msCoID: this.msCoID, orderStatus: undefined, attrJson: formatAttrJson, businessType: '1' })
                    .then((res: any) => {
                        this.isSpinning = false;
                        let { code, message, data } = res;
                        if (code == 200) {
                            location.replace(data)
                        } else {
                            this.modal.error({
                                nzTitle: '提示',
                                nzContent: message,
                                nzOnOk: () => console.log('OK')
                            });
                        }
                        $btn.button('reset');
                    })
            }
            let arr = []
            this.mustData2.forEach(item => {
                if (!this.attrJson[item.name].value) {
                    arr.push(item.cn)
                }
            })
            if (arr.length > 0) {
                this.modal.confirm({
                    nzTitle: '提示',
                    nzContent: `${arr.join('、')} 未匹配系统港口，是否仍然提交？`,
                    nzOnOk: submit
                });
            } else {
                submit()
            }

        }

    }
    isVisible = false
    handleCancel() {
        this.isVisible = false
    }
    handleOk() {
        this.isVisible = false
    }
    openModal() {
        this.isVisible = true
    }
    noticeLoading = false;
    isSpinningModal = false;
    getWarehousingNotice(event) {
        let arr = []
        this.mustData2.forEach(item => {
            if (!this.attrJson[item.name].value) {
                arr.push(item.cn)
            }
        })
        if (arr.length > 0) {
            this.modal.warning({
                nzTitle: '提示',
                nzContent: `禁止提交订舱，以下信息不能为空!<br>${arr.join('、')}`,
                nzOnOk: () => console.log('OK')
            });
            return
        }

        this.noticeLoading = true
        this.isSpinningModal = true;
        let $btn = $(event.target).button('loading...')
        const { portOfLoadingStandard = defalutValue, portOfDischargeStandard = defalutValue, portOfDestinationStandard = defalutValue } = this.attrJson;
        if (this.attrJson.etd.value) {
            this.attrJson.etd.value = format(new Date(this.attrJson.etd.value), 'yyyy-MM-dd');
        }
        const formatAttrJson = {
            ...this.attrJson, portOfLoadingStandard: { value: portOfLoadingStandard.value.split(';')[0] }, // 起运港
            portOfDischargeStandard: { value: portOfDischargeStandard.value.split(';')[0] }, // 卸货港
            portOfDestinationStandard: { value: portOfDestinationStandard.value.split(';')[0] },
        } // 目的港 }

        this._localDataService.saveIdentDetailsNew({ token: this.token, orderNo: this.orderNo, msCoID: this.msCoID, orderStatus: undefined, attrJson: formatAttrJson, businessType: '2' })
            .then((res: any) => {
                this.noticeLoading = false
                this.isSpinningModal = false
                let { code, message, data } = res;
                $btn.button('reset');
                if (code == 200) {
                    location.replace(data)
                } else {
                    this.modal.error({
                        nzContent: message
                    });
                }
            })
    }

    randomUserUrl = 'https://api.randomuser.me/?results=5';
    searchChange$ = new BehaviorSubject({});
    optionList: any = {};
    selectedUser;
    isLoading = false;
    tooltipOpen = true
    ngOnInit() {
        this._activatedRoute.queryParams.subscribe(params => {
            if (params.delays > 0) {
                this.setDelays = params.delays;
            }
        })


        this._activatedRoute.params.subscribe((params => {
            this.token = params.token;
            this.orderNo = params.orderNo;
            this.identifyData(params);
            this.getSomeType();
        }))
        const getRandomNameList = async ({ value, optionsKey, type, url }) => {
            if (value || ['serviceTerm', 'paymenTerm', 'packing'].includes(optionsKey)) {
                if (type === 'PackPlural') { type = (/^[1-9]+[0-9]*]*$/.test(this.attrJson.numberOfPieces.value) && this.attrJson.numberOfPieces.value > 1) ? type : 'PackSingular'; }

                if (url === 'getShippingConfig') {
                    const { data }: any = await this._localDataService.getShippingConfig({ type, value, token: this.token });
                    return { [optionsKey]: data }
                }

                if (url === 'getCodeByNameSc') {
                    const { data }: any = await this._localDataService.getCodeByNameSc({ type, orderNo: this.orderNo, portName: value, token: this.token })
                    console.log(data);

                    return { [optionsKey]: data.concat({ portName: value, portCode: '', countryName: '', countryCode: '', show: true }) }
                }

                return { [optionsKey]: [] }
            }
            return { [optionsKey]: [] };
        }
        const optionList$: Observable<{}> = this.searchChange$.asObservable().pipe(debounceTime(500)).pipe(switchMap(getRandomNameList));
        optionList$.subscribe(option => {
            this.optionList = Object.assign(this.optionList, option);
            this.isLoading = false;
        });

    }
    ngAfterViewInit() {
        const e = document.createEvent('Event');
        e.initEvent('resize', true, true);
        window.dispatchEvent(e)
    }


    onSearch(value: string, optionsKey: string, type: string, url = 'getShippingConfig'): void {
        this.isLoading = true;
        this.searchChange$.next({ value, optionsKey, type, url });
    }
    onSearchInit(e: Event, optionsKey: string, type: string, url = 'getShippingConfig'): void {
        let value = (this.attrJson[optionsKey].value || ';').split(';')[0];
        $(e.currentTarget).find('.ant-select-search__field').val(value)
        $(e.currentTarget).find('.ant-select-search__field')[0].dispatchEvent(new Event('input'));
        this.isLoading = true;
        this.searchChange$.next({ value, optionsKey, type, url });
    }
    onModelChange(value, key) {
        const [name, code] = (value || ";").split(';');
        const { portName = '', portCode = '' } = value ? this.optionList[key].filter(({ portName, portCode }) => (portName === name && portCode === code))[0] : {};
        const mp = key.replace('Standard', 'MP');
        this.attrJson[mp].value = portCode;
        this.attrJson[mp].msg = '';
        this.initCompiled() // 处理 etd 船期 时间 限制 
    }

    isSpinning = false
    today = new Date();
    compiled = (current) => {
        return false;
    };
    initCompiled = (sure = false) => {
        let msg: string[] = [];
        const { portOfLoadingMP, portOfDischargeMP, portOfDestinationMP } = this.attrJson
        if (portOfLoadingMP.value && portOfDischargeMP.value && portOfDestinationMP.value) {
            this._localDataService.getWtSailingsSc({
                token: this.token,
                portOfLoadingMP: portOfLoadingMP.value,
                portOfDischargeMP: portOfDischargeMP.value,
                portOfDestinationMP: portOfDestinationMP.value
            }).then((res: any) => {
                const { code, data: { date, dateTh } } = res;
                if (code === 200) {
                    try {
                        let week = [], days = [];
                        if (date.length) {
                            week = date.join('').split('').map((num => (num == '7' ? 0 : Number(num))));
                        }

                        if (dateTh.length) {
                            days = dateTh.map(date => (new Date(`${date} 08:00:00`).getTime()));
                            console.log(days);

                        }

                        this.compiled = (current) => {
                            return (!!week.length && !week.includes(new Date(current).getDay())) || days.includes(new Date(current).getTime())
                        }

                    } catch (error) {
                        console.error('etd 船期 转换失败  ');
                    }

                }
            })
        } else {
            msg.push('. 请补齐港口信息后再确认船期。');
        }
        if (!sure) {
            // sure 代表 调用来源, msg
            msg.push('. 港口发生变化，请检查船期是否正确。');
        }
        this.etdMsg = msg;
    }
    disabledDate = (current: Date): boolean => {
        const { portOfLoadingMP, portOfDischargeMP, portOfDestinationMP } = this.attrJson
        if (portOfLoadingMP.value && portOfDischargeMP.value && portOfDestinationMP.value) {
            console.log(current)
            return this.compiled(current) || differenceInDays(current, this.today) < 0;
        }
        // return [1,3].includes(new Date(current).getDay());
        return differenceInDays(current, this.today) < 0;
    }
    etdMsg: string[] = []
    handleEtdMsg = (etdMsg = []) => (etdMsg.map((text, num) => ((num + 1) + text))).join('\n')
    warnings = {
        numberOfPieces: {
            msg: '',
            rule: /^\d{1,4}$/,
            warning: '请注意输入格式：最多输入4位整数，无小数。'

        },
        grossWeight: {
            msg: '',
            rule: /^\d{1,5}(\.\d{1,3})?$/,
            warning: '请注意输入格式：最多输入5位整数和3位小数。请使用小数点分隔整数和小数部分，如：12345.678。'
        },
        volume: {
            msg: '',
            rule: /^\d{1,4}(\.\d{1,3})?$/,
            warning: '请注意输入格式：最多输入4位整数和3位小数。请使用小数点分隔整数和小数部分，如：1234.567。'
        },
    };
    warningMsg = (key, value) => {
        let str = ''
        const { rule, warning } = this.warnings[key];
        if (!(rule.test(value)) && value) {
            str = warning;
        }
        this.warnings[key].msg = str
    }

}



// WEBPACK FOOTER //
// /srv/jenkins-test/workspace/dev-doc-web/src/app/component/identificationNew/identification.ts